import React from 'react';
import {Table} from '@/web-components';
import {getGroupedRowColumns} from './TimeRegistrationReportTableUtil';

export const getBaseLevelTableHeaderTotals = tableHeader => {
	const columns = getGroupedRowColumns(
		{
			actualHours: tableHeader.wholeTableReportedTime,
			billableHours: tableHeader.wholeTableBillableRegistered,
			nonBillableHours: tableHeader.wholeTableNonBillableRegistered,
			actualBillableValueOfService: tableHeader.wholeTableTotalPrice,
			actualCost: tableHeader.wholeTableTotalCost,
		},
		// The same definitions the header maps, so the two cannot drift.
		tableHeader.customFieldDefinitions
	);

	const emptyRow = new Array(columns.length);

	return (
		<Table.Rows data={{rows: [emptyRow]}} canExpand={false} hasHeader>
			{({tableColumnsProps}) => {
				return <Table.Row {...tableColumnsProps}>{columns}</Table.Row>;
			}}
		</Table.Rows>
	);
};
